import PropTypes from 'prop-types';
import React from 'react';
import { trackEvent } from 'helpers/Analytics';
import getJobsResultsHeading from './getJobsResultsHeading';
import styles from './JobsResultsHeader.module.scss';

const JobsResultsHeader = ({
  pageType,
  filterCount,
  selectedRoleName,
  country,
  city,
  auth,
  onBestMatchNavigate,
}) => {
  const heading = getJobsResultsHeading({
    pageType,
    filterCount,
    selectedRoleName,
    country,
    city,
  });

  const handleBestMatch = (event) => {
    event.preventDefault();
    trackEvent('jobs-best-match-clicked', {
      source: 'heading',
      pageType,
      auth,
      filterCount,
    });
    if (onBestMatchNavigate) {
      onBestMatchNavigate();
    }
  };

  return (
    <div className={styles.header} data-testid="jobs-results-header">
      <h2 className={styles.heading} data-testid="jobs-results-heading">
        {heading}
      </h2>
      <p className={styles.sourceLine}>
        Jobs on Twine, newest first.{' '}
        <a
          href="/ari"
          className={styles.bestMatchLink}
          onClick={handleBestMatch}
          data-testid="jobs-best-match-heading"
        >
          Try Best match
        </a>
      </p>
    </div>
  );
};

JobsResultsHeader.propTypes = {
  pageType: PropTypes.oneOf(['jobs', 'role', 'country']).isRequired,
  filterCount: PropTypes.number,
  selectedRoleName: PropTypes.string,
  country: PropTypes.string,
  city: PropTypes.string,
  auth: PropTypes.oneOf(['guest', 'logged_in']).isRequired,
  onBestMatchNavigate: PropTypes.func,
};

JobsResultsHeader.defaultProps = {
  filterCount: 0,
  selectedRoleName: '',
  country: null,
  city: null,
  onBestMatchNavigate: undefined,
};

export default JobsResultsHeader;
